import styled from 'styled-components';
import { rem } from 'polished';
import { ModalFindDealerStyled } from '../ModalFindDealerStyled';
export const ModalFindDealerStyledOV = styled(ModalFindDealerStyled)`
    .modalHeader {
        .modalTitle {
            font-size: ${rem('38px')};
            color: black;
        }
    }

    .geolocation-input--container > .geolocation-input--textfield-container > input {
        border-radius: unset;
        border-color: ${({ theme }) => theme.colors.grey18};
    }

    .Select__indicators > div svg {
        display: flex;
        transform: rotate(180deg);

        path {
            fill: black;
        }
    }

    .modalDealerSelect {
        .Select__control {
            border-radius: unset;
            border-color: ${({ theme }) => theme.colors.grey18};
        }
    }

    .modalContent {
        margin-top: ${rem('24px')};
        line-height: 1.38;

        .modalAddr {
            font-size: ${rem('16px')};
            margin-bottom: ${rem('16px')};

            .name {
                font-weight: bold;
            }
        }
    }

    .modalOpeningHours {
        font-size: ${rem('16px')};
        line-height: 1.38;
    }
`;
